import React from 'react';
import { Rnd } from 'react-rnd';
import './deviceDOMHoc.css';
import {
  inject,
  observer,
} from 'mobx-react';

export default function deviceDOMHoc(WrappedComponent) {
  @inject('sidebarStore')
  @observer
  class DeviceDomHoc extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        dragging: false,
        resizing: false,
      };
      this.component = props;
    }

    onDrag = () => {
      this.setState({ dragging: true });
    };

    onDragStop = (e, d) => {
      setTimeout(() => {
        this.setState({ dragging: false });
      }, 100);

      if (d.x !== this.props.x || d.y !== this.props.y) {
        this.props.onUpdate({
          x: d.x > 0 ? d.x : 0,
          y: d.y > 0 ? d.y : 0,
        });
      }
    };

    onResize = (e, direction, ref, delta, position) => {
      this.setState({ resizing: true });
      this.props.onUpdate({
        length: ref.style.width.replace('px', '') * 1,
        size: ref.style.height.replace('px', '') * 1,
        ...position,
      });
    };

    onResizeStop = () => {
      setTimeout(() => {
        this.setState({ resizing: false });
      }, 100);
    };

    renderEdit() {
      if (this.props.isSmallScreen) {
        return;
      }
      const { onEdit } = this.props;

      return (
        <a
          className="btn btn-circle btn-icon-only btn-default btn-xs device-dom__edit"
          title={'Edit device'}
          onClick={onEdit}
        >
          <i className="icon-pencil" />
        </a>
      );
    }

    renderDelete() {
      if (this.props.isSmallScreen) {
        return;
      }
      const { onDelete } = this.props;

      return (
        <a
          className="btn btn-circle btn-icon-only btn-default btn-xs device-dom__delete"
          title={'Delete'}
          onClick={onDelete}
        >
          <i className="icon-trash" />
        </a>
      );
    }

    get shouldRenderActions() {
      const { device, sidebarStore } = this.props;
      return String(device.id).indexOf('extra-device') === -1 && sidebarStore.isOpen('devices');
    }

    render() {
      const { width, height, x, y, canDrag, className } = this.props;
      const { dragging, resizing } = this.state;
      const position = { x, y };
      const size = { width, height };

      return (
        <Rnd
          className={`device-dom__wrapper ${className}`}
          position={position}
          size={size}
          minWidth={80}
          minHeight={30}
          maxWidth={400}
          maxHeight={400}
          disableDragging={!canDrag}
          enableResizing={!canDrag ? null : {top: true, bottom: true, left: true, topRight: true, bottomRight: true, right: true}}
          lockAspectRatio={true}
          onDragStop={this.onDragStop}
          onDrag={this.onDrag}
          onResize={this.onResize}
          onResizeStop={this.onResizeStop}
        >
          <WrappedComponent
            {...this.props}
            dragging={dragging}
            resizing={resizing}
          />
          {this.shouldRenderActions && (
            <div>
              {this.renderEdit()}
              {this.renderDelete()}
            </div>
          )}
        </Rnd>
      );
    }
  }

  return DeviceDomHoc;
};
